import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { ActivityLogFeed } from "@/app/ActivityLogs/Components/ActivityLogFeed";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { ModelType } from "@/gql/graphql";

export function UserActivityDialog({ userId }: { userId: string }) {
  const { close } = useDialogState();

  return (
    <BaseDialog title={"User Activity"}>
      <ActivityLogFeed
        modelId={userId}
        modelType={ModelType.User}
        onLogged={close}
      />
    </BaseDialog>
  );
}
